import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "@phosphor-icons/react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { api } from "../../lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1567016958860-87d898933af1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800";
const imgErr = (e) => { e.currentTarget.src = FALLBACK; };

const BANNERS = [
  { title: "Lauksaimniekiem un lauku tehnikai", text: "UTTO un hidraulikas eļļas mucās, AdBlue, smērvielas — piegāde tieši uz saimniecību.", link: "/katalogs?category=ella", cta: "Skatīt eļļas", img: "https://images.unsplash.com/photo-1696441567908-6a04d49e1350?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200", big: true },
  { title: "Auto servisiem", text: "Apjoma cenas eļļām, filtriem un ķīmijai. Ātrā pasūtīšana pēc artikula.", link: "/b2b", cta: "B2B nosacījumi", img: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?auto=format&fit=crop&q=70&w=800" },
  { title: "Viss dārza tehnikai", text: "2-taktu eļļas, smērvielas un piederumi zāles pļāvējiem un motorzāģiem.", link: "/katalogs?q=2T", cta: "Skatīt preces", img: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&q=70&w=800" },
  { title: "Autoparkiem un pārvadātājiem", text: "Kravas auto eļļas 205L mucās, AdBlue lielos apjomos un apmaksa ar rēķinu.", link: "/b2b", cta: "Kļūt par B2B klientu", img: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?auto=format&fit=crop&q=70&w=800" },
];

export const AudienceBanners = () => (
  <section className="mx-auto max-w-7xl px-4 py-12 md:py-16">
    <h2 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Risinājumi jūsu nozarei</h2>
    <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5">
      {BANNERS.map((b, i) => (
        <Link key={i} to={b.link} data-testid={`audience-banner-${i}`}
          className={`card-industrial group relative flex min-h-[240px] items-end overflow-hidden border border-border ${b.big ? "md:col-span-2 md:row-span-1" : ""}`}>
          <img src={b.img} alt={b.title} loading="lazy" onError={imgErr} className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0c2a44]/95 via-[#0c2a44]/50 to-transparent" />
          <div className="relative p-6">
            <h3 className="font-heading text-xl font-semibold text-white">{b.title}</h3>
            <p className="mt-1.5 text-sm text-blue-100 max-w-md">{b.text}</p>
            <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-white group-hover:text-[#8FC1EA]">{b.cta} <ArrowRight size={16} /></span>
          </div>
        </Link>
      ))}
    </div>
  </section>
);

const REVIEWS = [
  { name: "Andris K.", company: "Zemnieku saimniecība \"Kalni\"", rating: 5, text: "Pasūtām hidraulikas eļļu mucās jau otro sezonu. Cenas krietni labākas nekā vietējiem tirgotājiem, un piegāde līdz saimniecībai 2 dienās." },
  { name: "Māris B.", company: "SIA AutoServiss Pro", rating: 5, text: "Ātrā pasūtīšana pēc artikuliem ietaupa laiku katru nedēļu. Rēķins pēcapmaksā — tieši tas, kas servisam vajadzīgs." },
  { name: "Ilze P.", company: "Privātpersona", rating: 5, text: "Pasūtīju ENEOS eļļu un PHILIPS spuldzes. Viss atbilst aprakstam, kurjers piegādāja nākamajā dienā." },
  { name: "Jānis R.", company: "SIA TransLat kravu pārvadājumi", rating: 4, text: "AdBlue un motoreļļas visam autoparkam ar apjoma atlaidi. Menedžeris sagatavoja piedāvājumu vienas dienas laikā." },
  { name: "Edgars S.", company: "Dārza tehnikas serviss", rating: 5, text: "Plašs 2-taktu eļļu un smērvielu klāsts. Ērti, ka viss vienuviet un cenas bez PVN uzreiz redzamas." },
  { name: "Līga V.", company: "SIA Būvnieks", rating: 5, text: "B2B reģistrācija aizņēma pāris minūtes, tagad visai tehnikai eļļas pērkam ar individuālu atlaidi." },
];

export const ReviewsSection = () => (
  <section className="bg-[#F4F8FC] border-y border-border">
    <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Ko saka mūsu klienti</h2>
          <p className="mt-1 text-sm text-slate-500">4.9 no 5 — vidējais vērtējums no 200+ atsauksmēm</p>
        </div>
      </div>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {REVIEWS.map((r, i) => (
          <div key={i} data-testid={`review-card-${i}`} className="rounded-2xl border border-border bg-white p-6">
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} size={16} weight="fill" className={s < r.rating ? "text-amber-400" : "text-slate-200"} />
              ))}
            </div>
            <p className="mt-3 text-sm leading-relaxed text-slate-700">"{r.text}"</p>
            <p className="mt-4 text-sm font-semibold">{r.name}</p>
            <p className="text-xs text-slate-500">{r.company}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const BlogSection = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}); }, []);
  if (posts.length === 0) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:py-16">
      <div className="flex items-end justify-between">
        <h2 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Padomi un raksti</h2>
        <Link to="/blogs" data-testid="blog-all-link" className="text-sm font-semibold text-[#2E86D1] hover:text-[#1F6DB2]">Viss blogs →</Link>
      </div>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {posts.map((b) => (
          <Link key={b.slug} to={`/blogs/${b.slug}`} data-testid={`blog-card-${b.slug}`} className="card-industrial group border border-border bg-white">
            <div className="aspect-[16/10] overflow-hidden bg-[#F4F8FC]">
              <img src={b.image} alt={b.title} loading="lazy" onError={imgErr} className="h-full w-full object-cover" />
            </div>
            <div className="p-5">
              <p className="text-xs text-slate-400">{new Date(b.date).toLocaleDateString("lv-LV")}</p>
              <h3 className="mt-1.5 font-heading text-base font-semibold leading-snug group-hover:text-[#2E86D1]">{b.title}</h3>
              <p className="mt-2 text-sm text-slate-500 line-clamp-2">{b.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

const FAQ = [
  { q: "Cik ātri tiek piegādātas preces?", a: "Preces no noliktavas piegādājam visā Latvijā 1–2 darba dienu laikā. Mucas (60L–205L) un IBC konteinerus piegādājam ar autoiekrāvēju līdz jūsu norādītajai adresei." },
  { q: "Vai varu norēķināties ar rēķinu?", a: "Jā, juridiskām personām piedāvājam apmaksu ar rēķinu (pēcapmaksu). Pēc pasūtījuma apstiprināšanas rēķinu nosūtīsim uz jūsu e-pastu, un preces tiek rezervētas uzreiz." },
  { q: "Kā darbojas apjoma atlaides?", a: "Katram produktam ir cenu līmeņi — jo lielāku daudzumu pērkat, jo zemāka cena par vienību. Cenu tabula redzama katra produkta lapā. B2B klientiem papildus piemērojam individuālu atlaidi." },
  { q: "Kā kļūt par B2B klientu?", a: "Reģistrējieties, atzīmējot \"Reģistrēties kā B2B klients\" un norādot uzņēmuma datus. Pēc apstiprināšanas jūsu kontam tiks aktivizēta individuālā atlaide un pēcapmaksas iespēja." },
  { q: "Vai preces var atgriezt?", a: "Jā, preci var atgriezt 14 dienu laikā no saņemšanas brīža, ja tā nav lietota un ir oriģinālajā iepakojumā." },
  { q: "Vai palīdzēsiet izvēlēties pareizo eļļu?", a: "Protams! Izmantojiet detaļu meklētāju pēc automašīnas mūsu sākumlapā vai sazinieties ar mums — palīdzēsim izvēlēties eļļu atbilstoši ražotāja specifikācijām." },
];

export const FaqSection = () => (
  <section className="mx-auto max-w-3xl px-4 py-12 md:py-16">
    <h2 className="text-center font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Biežāk uzdotie jautājumi</h2>
    <Accordion type="single" collapsible className="mt-6" data-testid="faq-accordion">
      {FAQ.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`}>
          <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-sm font-semibold hover:text-[#2E86D1] hover:no-underline">{f.q}</AccordionTrigger>
          <AccordionContent className="text-sm leading-relaxed text-slate-600">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
